import { render, staticRenderFns } from "./ui-explain-desc.vue?vue&type=template&id=dd8a689a&scoped=true&"
import script from "./ui-explain-desc.vue?vue&type=script&lang=js&"
export * from "./ui-explain-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8a689a",
  null
  
)

export default component.exports